// Third-party
import React, { ReactNode } from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from './NoDataCell';

type Props = {
  value?: string | number | ReactNode;
  className?: string;
  onClick?: () => void;
  id?: string;
};

const GenericCell: React.FunctionComponent<Props> = ({ value, className, onClick, id }: Props) => {
  if (value == null) {
    return <NoDataCell onClick={onClick} id={id} />;
  }

  return (
    <div className={classNames('cell generic-cell', className)} onClick={onClick} id={id ? `cell-${id}` : undefined}>
      <span className="markup-container">{value}</span>
    </div>
  );
};

export default GenericCell;
